import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class leadsServices extends ApiBaseService {
    constructor(public http: HttpClient) {
        super(http, '/leads');
    }

    /**
     * Mark a lead as lost with a specific reason
     * Called when an outcome with mark_lead_as_lost is selected
     */
    markLeadAsLost(leadId: number, lostReasonId: number, notes?: string): Observable<any> {
        return this.http.post(`${environment.apiUrl}/leads/${leadId}/close`, {
            lost_reason_id: lostReasonId,
            notes: notes
        });
    }

}
